import { render, staticRenderFns } from "./spolki-branzy-kosmicznej.md?vue&type=template&id=b2b11a14&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports